import { initializeApp } from 'firebase/app';
import { ActionCodeSettings, getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GCP_API_KEY,
  appId: process.env.REACT_APP_GCP_APPID,
  authDomain: process.env.REACT_APP_GCP_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_GCP_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_GCP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GCP_STORAGE_BUCKET,
};

const app = initializeApp(firebaseConfig);
const dbId = process.env.REACT_APP_GCP_FIRESTORE_DB_ID ?? '(default)';
export const auth = getAuth(app);
export const db = getFirestore(app, dbId);
const functionsRegion = process.env.REACT_APP_FUNCTIONS_REGION || 'asia-northeast1';
export const functions = getFunctions(app, functionsRegion);
export const storage = getStorage();
// マスタCSV用バケット。Functions の MASTER_VERIFICATION_BUCKET と同じバケットを指す必要がある
// （環境ごとに dev-master-verification 等が異なるため env で切替。未設定時は従来値にフォールバック）。
const masterVerificationBucket =
  process.env.REACT_APP_MASTER_VERIFICATION_BUCKET || 'master-verification';
export const masterStorage = getStorage(
  app,
  masterVerificationBucket.startsWith('gs://')
    ? masterVerificationBucket
    : `gs://${masterVerificationBucket}`,
);

// ローカル開発環境でエミュレータを使用
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
  } catch {
    // エミュレータ接続失敗時は通常のFirebaseに接続
  }
}

export const redirectUrl = (email: string): string => {
  const params = `?email=${email}`;
  return `${window.location.protocol}//${window.location.host}/staff/register` + `${params}`;
};

export const actionCodeSettings = (email: string): ActionCodeSettings => {
  const url: string = redirectUrl(email);
  return {
    handleCodeInApp: true,
    url,
  };
};

export const passwordSendSettings = (): ActionCodeSettings => ({
  handleCodeInApp: true,
  url: `${window.location.protocol}//${window.location.host}/auth/password_change`,
});
